<script setup lang="ts">
import manufacturerLogo from '@/assets/images/logo.png';
import { useAuthenticationStore } from '@/stores/authenticationStore';
import { useSystemStore } from '@/stores/systemStore';
import { EMPTY_FIELD_SIGN } from '../forms/utils';
import SimpleLayoutPrototypeWarning from '../layouts/SimpleLayout/SimpleLayoutPrototypeWarning.vue';
import SoftwareComponentColumn from './SoftwareComponentColumn.vue';
import { computed } from 'vue';
import { formatVersion } from '@/utils/stringUtils';

const systemStore = useSystemStore();
const authStore = useAuthenticationStore();

const version = computed(() => formatVersion(systemStore.version));
const installationName = computed(() => systemStore.siteName ?? EMPTY_FIELD_SIGN);
const ipin = computed(() => authStore.session?.ipin ?? EMPTY_FIELD_SIGN);

const emit = defineEmits<{
  goSoupPage: [];
}>();

function onCreditsClicked() {
  emit('goSoupPage');
}
</script>

<template>
  <div class="section">
    <v-row class="mb-4">
      <v-col cols="12" sm="4">
        <p class="v-label-overwrite">
          {{ $t('InstalledVersion') }}
        </p>
        <p class="mb-4">{{ version }}</p>
      </v-col>
      <v-col cols="12" sm="4">
        <p class="v-label-overwrite">
          {{ $t('InstallationName') }}
        </p>
        <p class="mb-4">{{ installationName }}</p>
      </v-col>
      <v-col cols="12" sm="4">
        <p class="v-label-overwrite">
          {{ $t('InstallationPIN') }}
        </p>
        <p class="mb-4">{{ ipin }}</p>
      </v-col>
      <v-col cols="12" class="d-flex justify-sm-end pt-0">
        <img
          :src="manufacturerLogo"
          alt="PTW"
          style="max-width: 100%; height: auto"
          class="ptw-logo"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pb-0">
        <hr class="mb-4" />
        <p class="text-h4">
          {{ $t('Included') }}
        </p>
      </v-col>
    </v-row>

    <v-row class="mb-4">
      <v-col
        v-for="task in systemStore.taskTypes"
        :key="task.taskTypeId ?? task.taskTypeNameEn ?? task.nameKey ?? ''"
      >
        <SoftwareComponentColumn :task="task" />
      </v-col>
    </v-row>

    <v-row class="mb-4">
      <v-col>
        {{ $t('SOUPLinkText') }}
        <a
          class="link"
          href="#"
          activeClass="active"
          data-nav-item
          @click.prevent="onCreditsClicked"
        >
          {{ $t('OpenSourceSoftware') }} </a
        >.
      </v-col>
    </v-row>

    <SimpleLayoutPrototypeWarning v-if="systemStore.isPrototype" class="mt-10" />
  </div>
</template>

<style lang="scss" scoped>
.ptw-logo {
  width: 170px;
  height: auto;
}
</style>
